import React, { useState, useEffect } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { DataGrid, esES } from '@mui/x-data-grid';
import { Assignment, Dialpad } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { WithApp } from 'contexts/appContext';
import { wsFindBy, wsGet } from 'services/WService';
import PaymentRDocDetail from './PaymentRDocDetail';
import { Toasty, useToasty } from 'hooks/Toasty';
import { useParams } from 'react-router';
import moment from 'moment';
import { IconButton, Tooltip } from '@material-ui/core';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

export default WithApp(function PayDocument(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [notify, showNotify] = useToasty();

  //#region  listado
  const [documents, setDocuments] = useState([]);
  const [totalPay, setTotalPay] = useState(0);
  const [bPartner, setBPartner] = useState({});
  const [handlePay, setHandlePay] = useState(0);

  async function getBPartner() {
    let response = await wsGet('base/business-partner', id);
    if (response.success) {
      getDocuments(response.data.CardCode, response.data.CardType);
      setBPartner(response.data);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function getDocuments(CardCode, CardType) {
    let response, creditNotesResponse;
    if (CardType === 'C') {
      [response, creditNotesResponse] = await Promise.all([
        wsFindBy('sap/business-partner/receivable', { CardCode }),
        wsFindBy('sap/business-partner/credit-note', { CardCode, pendient: 1 })
      ]);
    } else {
      response = await wsFindBy('sap/provider/receivable', { CardCode });
    }
    let creditNotes = [];
    if (creditNotesResponse !== undefined) {
      if (creditNotesResponse.success) {
        if (Array.isArray(creditNotesResponse.data)) {
          creditNotes = creditNotesResponse.data;
        }
      }
    }

    if (response.success) {
      let newData = response.data.map((item) => {
        let mObject = {
          ...item,
          totalPaid: item.Saldo,
          creditNotes: [],
          totalCN: 0
        };
        let filterCN = creditNotes.filter((cn) => {
          return (
            cn.U_SYP_MDSO === item.U_SYP_MDSD && // Serie
            cn.U_SYP_MDCO === item.U_SYP_MDCD && // Correlativo
            cn.U_SYP_MDTO === item.U_SYP_MDTD
          ); // Tipo documento
        });

        if (filterCN.length > 0) {
          mObject.creditNotes = filterCN;
          mObject.totalCN = filterCN.reduce(
            (reducer, cn) => reducer + (parseFloat(cn.DocTotal) - parseFloat(cn.PaidToDate)),
            0
          );
          mObject.totalPaid -= mObject.totalCN;
        }

        return mObject;
      });
      if (creditNotes.length > 0) {
        for (let i = newData.length - 1; i >= 0; i--) {
          let documento = newData[i];
          if (documento.creditNotes.length > 0) {
            newData.splice(i + 1, 0, ...documento.creditNotes);
          }
        }
      }
      /* console.log(newData); */
      /* setDocuments([...data, ...newData]); */
      setDocuments(newData);
    }
  }
  //#endregion

  //#region  tabla editable
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectionIds, setSelectionIds] = useState([]);
  const [clearTAble, setClearTAble] = useState(false);

  function calculation(selectedRowData) {
    let total = selectedRowData
      .filter((item) => !isNaN(item.totalPaid))
      .reduce((sum, item) => sum + item.totalPaid, 0);
    setTotalPay(total); //setea suma de los valores seleccionados
  }

  function editCell(e) {
    //actualizando la propiedad de pago.
    let objIndex = documents.findIndex((obj) => `${obj.ObjType}-${obj.DocEntry}` == e.id);
    // documents[objIndex].totalPaid = parseFloat(e.props.value); // esta linea se usaba en una version pero luego desaparecio de la documentacion oficial
    documents[objIndex].totalPaid = parseFloat(e.value);
  }

  function reload() {
    setSelectionModel([]);
    setSelectionIds([]);
    getBPartner();
    setTotalPay(0);
    setHandlePay(0);
    setClearTAble(!clearTAble);
  }

  /**
   * Genera un id para identificar un documento en el dataGrid
   * @param {ObjType, DocEntry, U_SYP_MDSO, U_SYP_MDCO} document
   * @returns string
   */
  function generateId(document) {
    return `${
      document.ObjType
    }-${document.DocEntry}${document.ObjType == 14 ? `-${document.U_SYP_MDSO}|${document.U_SYP_MDCO}` : ''}`;
  }

  const columns = [
    {
      field: 'num',
      width: 10,
      align: 'right',
      headerName: '#',
      disableColumnMenu: 100,
      hideable: false,
      sortable: false
    },
    {
      field: 'DocSubDescription',
      width: 100,
      headerName: 'T.Doc Sun.',
      hideable: false,
      sortable: false
    },
    { field: 'U_SYP_MDSD', width: 100, headerName: 'Serie Doc.', hideable: false, sortable: false },
    { field: 'U_SYP_MDCD', width: 100, headerName: 'Corr. Sun.', hideable: false, sortable: false },
    { field: 'DocNum', width: 100, headerName: 'Num. SAP', hideable: false, sortable: false },
    {
      field: 'DocStatus',
      width: 100,
      headerName: 'Esta Doc.',
      disableColumnMenu: 100,
      hideable: false,
      sortable: false
    },
    { field: 'TaxDate', width: 100, headerName: 'Fec. Doc.', hideable: false, sortable: false },
    { field: 'DocDueDate', width: 100, headerName: 'Fec. Vto.', hideable: false, sortable: false },
    { field: 'backDay', width: 100, headerName: 'Dias atrás', hideable: false, sortable: false },
    {
      field: 'DiscPrcnt',
      width: 70,
      align: 'right',
      headerName: '%Dsct.',
      hideable: false,
      sortable: false
    },
    {
      field: 'DocTotal',
      width: 100,
      align: 'right',
      headerName: 'Total Doc.',
      hideable: false,
      sortable: false
    },
    {
      field: 'PaidToDate',
      width: 100,
      align: 'right',
      headerName: 'Pagado',
      hideable: false,
      sortable: false
    },
    {
      field: 'Saldo',
      width: 100,
      align: 'right',
      headerName: 'Saldo',
      hideable: false,
      sortable: false
    },
    {
      field: 'creditNotes',
      width: 100,
      align: 'right',
      headerName: 'Mto. NC',
      sortable: false,
      type: 'number',
      disableColumnMenu: true
    },
    {
      field: 'totalPaid',
      width: 150,
      align: 'right',
      type: 'number',
      editable: true,
      headerName: 'Pago T.',
      renderCell: (cellValue) => {
        let tooltipMsg = '';
        if (handlePay > 0) {
          if (handlePay > totalPay) {
            tooltipMsg = 'Agrega Doc.';
          } else if (handlePay == totalPay) {
            tooltipMsg = 'Completo';
          } else if (cellValue.value < totalPay - handlePay) {
            tooltipMsg = 'Desmarcar';
          } else {
            tooltipMsg = `= ${(cellValue.value - (totalPay - handlePay)).toFixed(2)}`;
          }
        }
        return (
          <div>
            {selectionModel.some((x) => x.DocEntry === cellValue.id) ? (
              <Tooltip title={tooltipMsg}>
                <IconButton aria-label="delete">
                  <Dialpad fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : undefined}
            {cellValue.value}
          </div>
        );
      }
    }
  ];

  //#endregion tabla editable

  function mergeData(ids) {
    let difference = ids.length - selectionIds.length;
    let addeds = [];
    let deleteds = [];
    if (difference > 0) {
      if (difference === 1) {
        addeds[0] = ids.find((item) => !selectionIds.includes(item));
      } else {
        addeds = ids.filter((item) => !selectionIds.includes(item));
      }
    } else {
      if (difference === -1) {
        deleteds[0] = selectionIds.find((item) => !ids.includes(item));
      } else {
        deleteds = selectionIds.filter((item) => !ids.includes(item));
      }
    }

    if (addeds.length > 0) {
      for (let documentId of addeds) {
        let data = documentId.split('-');
        if (data[0] === '13') {
          let document = documents.find((item) => item.DocEntry === data[1]);
          if (document.creditNotes?.length > 0) {
            ids = ids.concat(document.creditNotes.map((item) => generateId(item)));
          }
        }
      }
    }

    if (deleteds.length > 0) {
      for (let documentId of deleteds) {
        let data = documentId.split('-');
        if (data[0] === '13') {
          let document = documents.find((item) => item.DocEntry === data[1]);
          if (document.creditNotes?.length > 0) {
            for (let cnId of document.creditNotes.map((item) => generateId(item))) {
              let index = ids.indexOf(cnId);
              if (index !== -1) {
                ids.splice(index, 1);
              }
            }
          }
        }
      }
    }

    setSelectionIds(ids);
  }

  useEffect(() => {
    getBPartner();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <span style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <h4 className={classes.cardIconTitle}>
                Documentos pendientes de pagos:{' '}
                <b>
                  {bPartner.CardName} ({bPartner.CardCode})
                </b>
              </h4>
            </span>
          </CardHeader>
          <CardBody>
            <div style={{ height: 500, width: '100%' }}>
              <DataGrid
                key={clearTAble}
                // localeText={esES.props.MuiDataGrid.localeText} // esta linea se usa en la version 4
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                checkboxSelection
                rowHeight={35}
                columns={columns}
                rows={documents.map((item, i) => {
                  let id = generateId(item);
                  return {
                    id,
                    ObjType: item.ObjType,
                    num: i + 1,
                    DocSubDescription: item.DocSubDescription,
                    U_SYP_MDSD: item.U_SYP_MDSD,
                    U_SYP_MDCD: item.U_SYP_MDCD,
                    DocNum: item.DocNum,
                    DocStatus: item.DocStatus === 'O' ? 'Abierto' : 'Cerrado',
                    TaxDate: moment(item.TaxDate).format('DD/MM/YYYY'),
                    DocDueDate: moment(item.DocDueDate).format('DD/MM/YYYY'),
                    backDay: moment().diff(moment(item.DocDueDate), 'days') + ' días',
                    DiscPrcnt: item.DiscPrcnt,
                    DocTotal: item.DocTotal,
                    PaidToDate: item.PaidToDate,
                    Saldo: item.Saldo,
                    creditNotes: item.totalCN,
                    totalPaid: parseFloat(item.totalPaid || 0).toFixed(2)
                  };
                })}
                //este codigo funcionaba con una version, luego desaparecio de la documentacion (onEditCellChange)
                /* onEditCellChange={(e) => {
                  editCell(e);
                  calculation(selectionModel);
                }} */
                onCellEditCommit={(e) => {
                  editCell(e);
                  calculation(selectionModel);
                }}
                isCellEditable={(itemId) =>
                  selectionModel.some(
                    (x) => `${x.ObjType}-${x.DocEntry}` === itemId.id && parseInt(x.ObjType) !== 14
                  )
                }
                selectionModel={selectionIds}
                disableSelectionOnClick
                isRowSelectable={({ row }) => parseInt(row.ObjType) !== 14}
                onSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  const selectedRowData = documents.filter((row) =>
                    selectedIDs.has(`${row.ObjType}-${row.DocEntry}`)
                  );
                  setSelectionModel(selectedRowData); //setea data seleccionada
                  calculation(selectedRowData);
                  mergeData(ids);
                }}
              />
            </div>
          </CardBody>
        </Card>
      </GridItem>
      {selectionModel.length > 0 ? (
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <PaymentRDocDetail
                bPartnerId={id}
                bPartner={bPartner}
                totalPay={totalPay}
                showNotify={showNotify}
                setHandlePay={setHandlePay}
                reload={reload}
                docSelects={selectionModel.map((item) => {
                  let cn = [];
                  if (item?.creditNotes.length > 0) {
                    cn = item.creditNotes.map((item) => item.DocEntry);
                  }
                  return {
                    DocEntry: item.DocEntry,
                    ObjType: item.ObjType,
                    Sum: item.totalPaid,
                    CreditNotes: cn,
                    Saldo: item.Saldo
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      ) : undefined}
    </GridContainer>
  );
});
